module.exports = __webpack_public_path__ + "media/images/expert__selectedArrow--dark-ad232dccb0e72607d32943aa1d71ff71.png";